import { useContext } from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import {
  StopLossContext,
  useValidateStopLoss,
} from '@/App/tiles/orders/StopLossOrder/StopLossOrderCreationTile/stopLossContext';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTriggerStopLoss } from '@/store/orders/stopLoss/selectors.ts';
import type { Trigger } from '@/store/orders/stopLoss/state.ts';

export const StopLossTrigger = () => {
  const tileId = useContext(StopLossContext).tileId;
  const track = useTrackEvent();

  const trigger = useAppSelector((state) => selectTriggerStopLoss(state, tileId));

  const validateStopLoss = useValidateStopLoss();

  const handleChangeTrigger = (event: React.ChangeEvent<HTMLSelectElement>) => {
    track('Order action', 'Trigger changed');
    const newTrigger = event.target.value as Trigger;

    validateStopLoss({
      trigger: newTrigger,
    });
  };

  return (
    <OrderRow labelId="order.fields.trigger.label">
      <Form.Select value={trigger} onChange={handleChangeTrigger} size="sm" data-e2e="trigger-selector">
        <option value="Spot">
          <FormattedMessage id="order.fields.trigger.spot" />
        </option>
        <option value="BidOffer">
          <FormattedMessage id="order.fields.trigger.bidOffer" />
        </option>
        <option value="RateOneTouch">
          <FormattedMessage id="order.fields.trigger.rateOneTouch" />
        </option>
      </Form.Select>
    </OrderRow>
  );
};
